import React, { useState } from "react";

const Comments = ({blog}) => {
  const [showComments, setShowComments] = useState(false);

   const timeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffInSeconds = Math.floor((now - date) / 1000);

    const timeUnits = [
      { name: "year", seconds: 31536000 },
      { name: "month", seconds: 2592000 },
      { name: "day", seconds: 86400 },
      { name: "hour", seconds: 3600 },
      { name: "minute", seconds: 60 },
      { name: "second", seconds: 1 },
    ];

    for (const unit of timeUnits) {
      const interval = Math.floor(diffInSeconds / unit.seconds);
      if (interval >= 1) {
        return `${interval} ${unit.name}${interval > 1 ? "s" : ""} ago`;
      }
    }

    return "just now";
  };

  if (blog?.comments?.length === 0) {
    return (
      null
    )
  }

  return (
    <div className="container min-w-full md:px-[40px] lg:pb-[100px] md:pb-[60px] pb-[30px]">
      {blog?.comments?.length > 0 && (
      <button 
        onClick={() => setShowComments(!showComments)}
        className="py-5 w-full bg-ternaryBlack text-textWhite my-5 tracking-[4px] rounded hover:bg-ternaryBlack/90 transition-colors"
      >
        {showComments ? "Hide" : "Show"} Comments ({blog?.comments?.length})
      </button>
      )}

      {showComments && (
        <div className="max-h-[300px] overflow-y-auto space-y-5">
          {blog?.comments?.map((comment) => (
            <div key={comment?.id} className="flex p-4 bg-gray-50 rounded-lg">
              {/* <div className="w-[30px] min-w-[30px] h-[30px] rounded-full overflow-hidden mr-[15px]">
                <img 
                  src={comment?.user?.profilePic} 
                  alt={comment?.user?.name}
                  className="w-full h-full object-cover"
                />
              </div> */}
              
              <div className="flex flex-col gap-[5px]">
                <div className="flex flex-col gap-[5px]">
                  <h4 className="text-sm font-semibold">{comment?.user_id?.firstname + " " + comment?.user_id?.lastname}</h4>
                  <span className="text-xs text-gray-500">{timeAgo(comment?.created_at)}</span>
                </div>
                      <p dangerouslySetInnerHTML={{ __html: comment?.content }} />
                
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Comments;

// import React from "react";

// const Comments = () => {
//   return (
//     <div className="container min-w-full md:px-[40px] lg:mb-[100px] nd:mb-[60px] mb-[30px]">
//       <button className="py-5 w-full bg-ternaryBlack text-textWhite my-5 tracking-[4px] rounded">
//         View Comments (0)
//       </button>
//     </div>
//   );
// };

// export default Comments;